import React from 'react';
import Icon from '../../../components/AppIcon';

const StakeholderStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Stakeholders',
      value: stats?.total,
      change: '+12%',
      changeType: 'positive',
      icon: 'Users',
      color: 'primary'
    },
    {
      title: 'Active This Week',
      value: stats?.activeThisWeek,
      change: '+8%',
      changeType: 'positive',
      icon: 'UserCheck',
      color: 'success'
    },
    {
      title: 'Pending Invitations',
      value: stats?.pendingInvitations,
      change: '-3%',
      changeType: 'negative',
      icon: 'UserPlus',
      color: 'warning'
    },
    {
      title: 'Avg Response Time',
      value: stats?.avgResponseTime,
      change: '-15%',
      changeType: 'positive',
      icon: 'Clock',
      color: 'accent'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      success: 'bg-success/10 text-success',
      warning: 'bg-warning/10 text-warning',
      accent: 'bg-accent/10 text-accent'
    };
    return colors?.[color] || 'bg-muted/10 text-muted-foreground';
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg border border-border shadow-soft p-6">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">{stat?.title}</p>
              <p className="text-2xl font-semibold text-foreground">{stat?.value}</p>
              <div className="flex items-center mt-2">
                <span className={`text-xs font-medium ${
                  stat?.changeType === 'positive' ? 'text-success' : 'text-error'
                }`}>
                  {stat?.change}
                </span>
                <span className="text-xs text-muted-foreground ml-1">from last month</span>
              </div>
            </div>
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StakeholderStats;